module.exports = __webpack_public_path__ + "img/image-thumb-5.2e05312d.webp";